import { render, staticRenderFns } from "./TipsModalBox.vue?vue&type=template&id=c8545eac&scoped=true&"
import script from "./TipsModalBox.vue?vue&type=script&lang=js&"
export * from "./TipsModalBox.vue?vue&type=script&lang=js&"
import style0 from "./TipsModalBox.vue?vue&type=style&index=0&id=c8545eac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8545eac",
  null
  
)

export default component.exports